// Imports
const $ = window.$;
const SuggestionBoxStatusTemplate = require('../../templates/tooltips/suggestion-box-status.handlebars');
const SuggestionBoxSuggestionsTemplate = require('../../templates/tooltips/suggestion-box-suggestions.handlebars');
const Utilities = require('../../lib/utilities.js');
const TooltipTemplate = require('../../templates/tooltips/tooltip.handlebars');

var controller = require('./controller.js')();

var M = {};
M.CurrentUniqueness = "unknown";

function positionEl($container, $el, offsetH, offsetV) {
    var width = $container.outerWidth(true);
    var ref = $container.offset();

    $el.css({
        "top": ref.top - $('.mainContent').offset().top + offsetV,
        "left": $el.outerWidth() + width + offsetH
    });
}

function resizeTooltip($container, height) {
    var $inners = $container.find('.communityid-tooltip, .tooltip-container, .tooltip-container-bg');
    $inners.css('height', height);
}

function AddTooltip($tooltipHolder, $el, msg, offsetH, offsetV) {
    offsetH = offsetH ? offsetH : 0;
    offsetV = offsetV ? offsetV : 0;

    var $tooltip = $(TooltipTemplate(msg));
    $tooltipHolder.html($tooltip);
    $tooltipHolder.removeClass('invalid');

    // Put it on the page so that we can steal the dimensions
    $tooltipHolder.show();
    var $tooltipContent = $tooltip.find('.tooltip-container-content');
    var width = $tooltipContent.outerWidth();
    var height = $tooltipContent.outerHeight();
    $tooltipHolder.hide();

    resizeTooltip($tooltipHolder, height);
    positionEl($el.parent(), $tooltip, offsetH, offsetV);


    //// get label
    $el.parent().prevAll('.label_container:first').addClass('highlighted');

    $tooltipHolder.show();
};

function AddTooltipEvents($tooltipHolder, $formEl, msg, offsetH, offsetV) {
    $formEl.on('focus', function (e) {
        AddTooltip($tooltipHolder, $(this), msg, offsetH, offsetV);
    }).on('mouseover', function (e) {
        AddTooltip($tooltipHolder, $(this), msg, offsetH, offsetV);
    }).on('blur', function (e) {
        $tooltipHolder.hide();
        $(this).parent().prevAll('.label_container:first').removeClass('highlighted');
    }).on('mouseleave', function (e) {
        $tooltipHolder.hide();
        $(this).parent().prevAll('.label_container:first').removeClass('highlighted');
    });
}

function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + "; " + expires + ";path=/";
};

function setupLearnMore() {
    var speed = 500;

    var page = {
        $link: $('a.learnMoreLink'),
        $info: $('.infoContainer'),
        $infoContent: $('.infoContainer .infoScreen'),
        $closeButton: $('.infoForm button')
    };

    page.$link.on('click', function () {
        Utilities.OpenModalInfo(page.$info, page.$infoContent, speed, page.$closeButton);
        return false;
    });
}

function getServerSuggestions(form) {
    Log.Trace('Getting server suggestions...');
    var fdata = {
        FirstName: form.$FirstName.val(),
        LastName: form.$LastName.val()
    };
    controller.GetSuggestions(fdata);
}

function switchSuggestionBoxClass($el, isUnique) {
    if (isUnique) {
        $el.removeClass('idIsNotUnique');
        $el.addClass('idIsUnique');
    } else {
        $el.removeClass('idIsUnique');
        $el.addClass('idIsNotUnique');
    }
}

function setSuggestionBoxStatus($el, isUnique, communityID) {
    var html = SuggestionBoxStatusTemplate({
        IsUnique: isUnique,
        CommunityID: communityID
    });
    $el.html(html);
}

function checkUniqueness(val) {
    if (!val || val.length < 6) {
        controller.OnUniqueResult.Notify({
            IsUnique: false,
            CommunityID: val
        });
    } else {
        controller.IsUnique({ communityID: val });
    }
}

function toggleVisibility(isUnique, $container, $suggestions) {
    $container.fadeIn(500);
    if (isUnique) {
        $suggestions.hide();
    }
}

$(document).ready(function () {
    var hash = window.location.hash;
    if (hash) {
        console.log('Setting hash cookie: ' + hash);
        setCookie('lastHash', hash, 1);
    }

    var $tooltipHolder = $('.tooltip-placeholder');

    // Hook up events
    var $form = $('form.signup-form');
    var form = {
        $CommunityID: $form.find('input[name="CommunityID"]'),
        $SuggestionBox: $form.find('.suggestion-box'),
        $SuggestionBoxStatus: $form.find('.suggestion-box-label-status'),
        $SuggestionBoxSuggestions: $form.find('.suggestion-box-suggestions'),
        $FirstName: $form.find('input[name="FirstName"]'),
        $LastName: $form.find('input[name="LastName"]'),
        $Email: $form.find('input[name="Email"]'),
        $ExistingEmail: $form.find('.existing-email'),
        $Password: $form.find('input[name="Password"]'),
        $ConfirmPassword: $form.find('input[name="ConfirmPassword"]'),
        $Passwords: $form.find('.passwords')
    };

    function setUniqueness(isUnique, communityID) {
        M.CurrentUniqueness = isUnique;
        toggleVisibility(isUnique, form.$SuggestionBox, form.$SuggestionBoxSuggestions)
        switchSuggestionBoxClass(form.$CommunityID, isUnique);
        setSuggestionBoxStatus(form.$SuggestionBoxStatus, isUnique, communityID);
        if (isUnique) {
            form.$Email.focus();
        } else {
            form.$CommunityID.focus();
            getServerSuggestions(form);
        }
    }

    controller.OnUniqueResult.Subscribe(function (obj, args) {
        // Get val again. Might have changed by now.
        var val = form.$CommunityID.val();
        if (args && val == args.CommunityID) {
            setUniqueness(args.IsUnique, val);
        }
    });

    controller.OnSuggestionsResult.Subscribe(function (obj, args) {
        form.$SuggestionBoxSuggestions.fadeOut(500, function () {
            var html = SuggestionBoxSuggestionsTemplate(args);
            form.$SuggestionBoxSuggestions.html(html);
        });
    });

    controller.OnValidPasswordResult.Subscribe(function (obj, args) {
        SetPasswordValidity(args.IsValid);
    });

    function SetPasswordValidity(isValid) {
        if (isValid) {
            form.$Password.removeClass('invalid');
            $tooltipHolder.find('.communityid-tooltip').removeClass('invalid');
        } else {
            form.$Password.focus();
            form.$Password.addClass('invalid');
            AddTooltip($tooltipHolder, form.$Password, passwordRestrictions, 1);
            $tooltipHolder.find('.communityid-tooltip').addClass('invalid');
        }
    }

    function ValidateConfirmPassword(doFocus) {
        var isValid = form.$Password.val() === form.$ConfirmPassword.val();

        if (isValid) {
            form.$ConfirmPassword.removeClass('invalid');
            $tooltipHolder.find('.communityid-tooltip').removeClass('invalid');
        } else {
            if (doFocus) {
                form.$ConfirmPassword.focus();
            }
            form.$ConfirmPassword.addClass('invalid');
            AddTooltip($tooltipHolder, form.$ConfirmPassword, 'Passwords do not match.', 1);
            $tooltipHolder.find('.communityid-tooltip').addClass('invalid');
        }
    }

    form.$CommunityID.on('change', function (e) {
        var val = form.$CommunityID.val();
        Log.Debug('Community ID changed [change]...', val);
        checkUniqueness(val);
    });

    $('body').on('click', 'a.show-options-link', function (e) {
        form.$SuggestionBoxSuggestions.fadeIn(500);
        e.preventDefault();
        return false;
    });

    form.$SuggestionBoxSuggestions.on('click', 'li.suggestion-box-suggestion a', function (e) {
        e.preventDefault();
        var val = $(e.currentTarget).text();
        form.$CommunityID.val(val);
        if (M.CurrentUniqueness !== true) {
            setUniqueness(true, val);
        }
        return false;
    })

    var passwordRestrictions = $('.password-restrictions').text();

    AddTooltipEvents($tooltipHolder, form.$CommunityID,
        "<p>Create your own personal Skyward <strong>Knowledge Hub ID</strong> for easy access to Skyward training and support services.</p><p>Your Knowledge Hub ID will be visible to other members of the community, so please keep it respectful.</p><p>Minimum length 6 characters.</p><p>Now go ahead, and <strong>make it your own!</strong></p>",
        2);
    if ($('.existing-email').length > 0) {
        AddTooltipEvents($tooltipHolder, form.$Email,
            "Enter the <strong>Email</strong> address with which you originally signed up.",
            2);
    } else {
        AddTooltipEvents($tooltipHolder, form.$Email,
            "Enter an <strong>Email</strong> address. This allows the Knowledge Hub to send you password reset emails if necessary.",
            2);
    }
    AddTooltipEvents($tooltipHolder, form.$Passwords,
        "<p>Create and confirm your own personal <strong>Password</strong> for your Skyward Knowledge Hub account.</p><p>" + passwordRestrictions + '</p>',
        2);

    form.$Password.on('change', function (e) {
        controller.ValidatePassword({ "Password": $(this).val() });
    });

    form.$ConfirmPassword.on('change', function (e) {
        ValidateConfirmPassword(true);
    });

    form.$ConfirmPassword.on('blur', function (e) {
        ValidateConfirmPassword(false);
    });

    setupLearnMore();

});



// WEBPACK FOOTER //
// ./Scripts/views/signup/signup.js